import { configProvider } from '@adonisjs/core'
import type { ConfigProvider } from '@adonisjs/core/types'
import type { TranslationConfig } from './types.js'

/**
 * Define translation configuration with type inference
 * Following AdonisJS pattern for better type safety
 */
export function defineConfig<Providers extends Record<string, any>>(
  config: TranslationConfig<Providers>
): ConfigProvider<TranslationConfig<Providers>> {
  return configProvider.create(async (_app) => {
    return config
  })
}
